export const STATUS_OPTIONS = [
    { value: "Planning" },
    { value: "Active" },
    { value: "Inactive" },
    { value: "Completed" },
];
export const TYPE_OPTIONS = [
    { value: "Conference" },
    { value: "Webinar" },
    { value: "Trade Show" },
    { value: "Public Relations" },
    { value: "Partners" },
    { value: "Referral Program" },
    { value: "Advertisement" },
    { value: "Banner Ads" },
    { value: "Direct Mail" },
    { value: "Email" },
    { value: "Telemarketing" },
    { value: "Others" },
];
export const CAMPAIGN_STATUS_OPTIONS = [
    { value: "Planned" },
    { value: "Invited" },
    { value: "Sent" },
    { value: "Received" },
    { value: "Opened" },
    { value: "Responded" },
    { value: "Bounced" },
    { value: "Opted Out" },
  ];